const qs                          = require('query-string');
const FileSaver                   = require('file-saver');
const endpoint                    = require('@readcube/endpoint');
const SyncApi                     = require('@readcube/sync-api-web');
const { default: SyncUploader }   = require('@readcube/sync-uploader');
const { default: openInPapers }   = require('@readcube/open-in-papers');
const AwsRUM                      = require('../includes/aws_rum');
const TrackJS                     = require('../includes/trackjs');
const DocdelPreview               = require('../index.js');
const clipboard                   = require('../util/clipboard');
const status                      = require('../util/status');
const guid                        = require('../util/guid');
const platform                    = require('../platform');
const { version }                 = require('../../../package.json');
const {
  parseEnv,
  parseDoi,
  notifyParent,
  libraryItemUrl
} = require('./helpers');

module.exports = function docdel() {
  console.log(`%c ### DOCDEL PREVIEW, version: ${version}`, 'font-weight: bold; color: gold;');
  notifyParent('loaded');

  const env = parseEnv();
  const doi = parseDoi();

  if (location.hostname != 'local.readcube.com') {
    try { TrackJS.install({ doi, env, version }); } catch (e) {}
    try { AwsRUM.install(env); } catch (e) {}
  }

  const client    = { name: 'docdel_preview', version, id: guid() };
  const syncApi   = SyncApi.create({ env, client, log: console });
  const uploader  = SyncUploader.create({ syncApi, log: console });

  platform.init('web');
  endpoint.init(env);
  notifyParent('initialized');

  const query = qs.parse(location.search);
  const test = {
    state: query.state,
    download: query.download,
    extension: query.extension,
    skip_cache: !!query.skip_cache,
    approval_required: !!query.approval_required,
    insufficient_funds: !!query.insufficient_funds,
    additional_details: !!query.additional_details
  };

  const importTo = query.import_to ?
    {
      collectionId: query.import_to.split(':')[0],
      id: query.import_to.split(':')[1]
    } : null;

  const dp = new DocdelPreview({
    env,
    doi,
    syncApi,
    uploader,
    importTo,
    test
  });

  window.addEventListener('load', () => {
    window.addEventListener('offline', () => status.onLine = navigator.onLine);
    window.addEventListener('online', () => status.onLine = navigator.onLine);
  });

  dp.evtout.on('open-pdf', (e, pdfBuffer) => {
    openInPapers({ pdfBuffer, doi, env, tab: true, addToLibrary: true, });
  });

  dp.evtout.on('open-pdf-url', (e, pdfUrl) => {
    openInPapers({ pdfUrl, doi, env, tab: true, addToLibrary: true, });
  });

  dp.evtout.on('open-url', (e, url, tab) => {
    tab ?
      window.open(url, '_blank') :
      location.href = url;
  });

  dp.evtout.on('author-search', (e, name, href) => {
    window.open(href, '_author_search');
  });

  dp.evtout.on('download', (e, url, name, blob) => {
    if (blob && name) {
      FileSaver.saveAs(blob, name);
    } else {
      window.open(url);
    }
  });

  dp.evtout.on('copy-to-clipboard', (e, text, html) => {
    clipboard.copy(text, html);
  });

  dp.evtout.on('open-in-library', (e, item) => {
    window.open(libraryItemUrl(item), '_webapp');
  });

  dp.evtout.on('read-in-library', (e, { collection_id, id }) => {
    window.open(`${endpoint.web}/library/${collection_id}:${id}`,
      '_personal_article');
  });

  dp.evtout.on('read-supplement', (e, { index }) => {
    window.open(`${endpoint.web}/articles/supplement?${qs.stringify({
      doi, index
    })}`, '_public_supplement');
  });

  dp.evtout.on('open-supplement', (e, sup) => {
    window.open(sup.download_url || sup.source_url);
  });
}
